import React from "react";
import { InfoRounded } from "@mui/icons-material";
import { InfoPopup } from "../InfoPopup";
import "./CompetitionExcluded.css";

/** What the marker's popup says: DaKasa still bids, and nothing else of the competition applies. */
export const COMPETITION_EXCLUDED_EXPLANATION =
  "A conta do DaKasa disputa as postagens, mas não soma ofensiva, não entra no ranking e não concorre aos prêmios do mês.";

/**
 * Stands where the offensive preview sits in the Átrio header, for DaKasa's own
 * company. Ads keeps that company out of the offensive competition (Ads ADR
 * 0018): it bids like any company, but earns no ofensiva, has no ranking
 * position and wins no monthly prize, so a preview of points it never gets
 * would mislead. The explanation is also the trigger's accessible name, since
 * the popup opens on hover only.
 *
 * The id is its own: `offensivePreviewContainer` stays the tour's anchor, and
 * the tour always runs on mock data, where every company competes.
 * @story ancestor #negotiationHomeContainer
 * @story css ../../routes/pages/negotiate.css
 */
export function CompetitionExcludedMarker() {
  return (
    <div className="competitionExcludedMarker" id="hallCompetitionExcluded">
      <span className="competitionExcludedMarkerLabel">Fora da competição</span>
      <InfoPopup
        position="s"
        id="hallCompetitionExcludedInfoPopup"
        classNameBox="competitionExcludedMarkerPopupBox"
        withArrow
        triggerElement={
          <span
            className="competitionExcludedMarkerInfo"
            role="img"
            aria-label={COMPETITION_EXCLUDED_EXPLANATION}
          >
            <InfoRounded aria-hidden="true" />
          </span>
        }
      >
        <span>{COMPETITION_EXCLUDED_EXPLANATION}</span>
      </InfoPopup>
    </div>
  );
}
